// ABOUTME: Validation schema for creating a support ticket, shared by the
// ABOUTME: relation-portal and warehouse modals. Warehouse also requires a relation.

import * as yup from "yup";
import { yupRequired } from "./validation";

export const buildSupportTicketSchema = (t, { requireRelation = false } = {}) =>
    yup.object().shape({
        title: yupRequired('title', t),
        ticketType: yupRequired('type', t),
        ...(requireRelation ? { relationId: yupRequired('relation', t) } : {}),
    });
